import { useEffect, useState } from 'react';

// Subscribe to a CSS media query from React. Layout that's purely visual belongs in Tailwind
// breakpoints — this is for the cases where the BREAKPOINT CHANGES WHAT RENDERS, not just how it
// looks: the sidebar's collapsed mode hides label elements entirely, so it can't be expressed as a
// CSS-only variant of the expanded tree.
//
// Starts false on the server / first paint and corrects in the effect. Everything using it must
// therefore be safe rendering the "small" branch for one frame — true here, since the desktop
// layout is the enhancement, not the baseline.
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    // jsdom implements matchMedia only behind a stub in some setups; guard so tests that don't
    // provide one render the small-screen branch instead of throwing.
    if (typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    setMatches(mql.matches);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

// The one breakpoint the app shell pivots on: at `lg` and up the sidebar is a permanent column,
// below it the sidebar is an off-canvas drawer. Kept here (not inlined at the call sites) so the
// JS-side breakpoint can never drift from the `lg:` Tailwind variants that lay out the same shell.
export const LG_UP = '(min-width: 1024px)';
